const entityRegex: RegExp = /&(?:amp|lt|gt|quot|#39|apos|nbsp);/g;

const entityMap: { [key: string]: string } = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&nbsp;': '\u00A0',
};

export function decodeHtmlEntities(str: string): string {
    return str.replace(entityRegex, (entity: string) => entityMap[entity] || entity);
}
